import { ArrowRight } from "lucide-react";
import logoCompany from "@/assets/logo-company.webp";
import ScrollReveal from "./ScrollReveal";

const CompanySection = () => {
  return (
    <section className="py-20 relative overflow-hidden bg-gradient-to-br from-primary via-primary to-[hsl(210,80%,35%)]">
      {/* Decorative orbs */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-accent/10 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-lavender/10 blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <ScrollReveal>
          <div className="flex flex-col md:flex-row items-center justify-between gap-10 max-w-5xl mx-auto glass rounded-3xl p-8 md:p-10 border-primary-foreground/10">
            <div className="flex items-center gap-5 text-center md:text-left">
              <img src={logoCompany} alt="Equilybra Company" width="332" height="211" loading="lazy" decoding="async" className="h-24 w-auto object-contain shrink-0 drop-shadow-lg" />
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-2">
                  Equilybra Company
                </h2>
                <p className="text-foreground/70 text-sm md:text-base max-w-lg leading-relaxed">
                  Conheça nosso setor especializado em serviços para empresas. Saúde mental corporativa, palestras, treinamentos e muito mais.
                </p>
              </div>
            </div>

            <a
              href="https://www.equilybracompany.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl bg-primary-foreground text-primary font-bold text-base hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl shrink-0"
            >
              Acesse o Site
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default CompanySection;
